import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { SectionDivider } from '../components/SectionDivider';
import { ProductSection } from '../components/ProductSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-519">
      <HeroSection data-id="element-520" />
      <StorySection data-id="element-521" />
      <PainSection data-id="element-522" />
      <MechanismSection data-id="element-523" />
      <SectionDivider data-id="element-524" />
      <AboutSection data-id="element-525" />
      <ProductSection data-id="element-526" />
      <TestimonialsSection data-id="element-527" />
      <OfferSection data-id="element-528" />
      <GuaranteeSection data-id="element-529" />
      <UrgencySection data-id="element-530" />
      <ObjectionsSection data-id="element-531" />
      <IdentitySection data-id="element-532" />
      <FinalCTASection data-id="element-533" />
      <Footer data-id="element-534" />
    </div>;
}